<div class="row mb-4">
  <div class="col-6 d-flex align-items-center"></div>
  <div class="col d-flex align-items-center">
    <div class="checkbox-control">
      <input id="display_service_type_icon" type="checkbox" [(ngModel)]="value" [disabled]="isDisabled" (change)="onCheckboxChange($event)" />
      <label for="display_service_type_icon" class="checkbox-control">{{ label }}</label>
    </div>
  </div>
</div>
